import React from "react";
import { ModalBody, Label, Input, Select, Common } from "@lainco/react-toolbox";
import { withCrudModal } from "../components/Modal";
import { useCandidates } from "../app/candidatesSlice";
import { useUser } from "../lib/userContext";

import Bank from "../model/Bank";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@lainco/fontawesome-regular";

export function BankModalContent({ model, onChange }) {
  const [countries, countriesLoading] = useCandidates("countries");
  // Check if user is sysadmin
  const user = useUser();
  const isSysAdmin = user?.roles?.includes("System Admin");

  return (
    <ModalBody>
      <Common.Row cols="2fr 1fr" gap="1em">
        <Label text="Name">
          <Input value={model.name} onChange={(x) => onChange({ ...model, name: x })} />
        </Label>
        <Label text="Country">
          <Select
            value={model.country?.id}
            onChangeOption={(x) => onChange({ ...model, country: x })}
            options={countries}
            loading={countriesLoading}
          />
        </Label>
      </Common.Row>
      {isSysAdmin && (
        <Common.Row cols="2fr" gap="1em" style={{ backgroundColor: "#eee", padding: "1em" }}>
          <Label
            text={
              <>
                <span>Api Keys</span>
                <Common.Link
                  onClick={() => {
                    onChange({ ...model, apiKeys: [...(model.apiKeys || []), ""] });
                  }}
                >
                  Add Key
                </Common.Link>
              </>
            }
          >
            {model.apiKeys?.map((k, i) => (
              <Common.Row cols="1fr auto" key={i}>
                <Input
                  value={k}
                  onChange={(x) => {
                    const newKeys = [...model.apiKeys];
                    newKeys[i] = x;
                    onChange({ ...model, apiKeys: newKeys });
                  }}
                />
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ cursor: "pointer", marginLeft: "1em", alignSelf: "end", color: "rgb(0, 146, 170)" }}
                  onClick={() => {
                    const newKeys = [...model.apiKeys];
                    newKeys.splice(i, 1);
                    onChange({ ...model, apiKeys: newKeys });
                  }}
                />
              </Common.Row>
            ))}
          </Label>
        </Common.Row>
      )}
    </ModalBody>
  );
}

export default withCrudModal(BankModalContent, Bank, "lg", false);
